module.exports = "<p>token-bm-link works!</p>\n"